import {Button, Link, Stack, Typography} from '@mui/material'
import {Trans, useTranslation} from 'react-i18next'
import {useAuthenticationContext, useUserContext} from '@goschool/auth'
import {LoadingPage, PageLayout} from '@goschool/components'
import {CoursesPage, WarningPage} from '@goschool/courses'
import {Welcome} from '../branding'
import LocationCityIcon from '@mui/icons-material/LocationCity'

export function LandingPage() {
  const {user, state, goSchoolUser} = useUserContext()
  const {signIn, signUp} = useAuthenticationContext()
  const {t} = useTranslation()

  if (state === 'pending') {
    return <LoadingPage/>
  }

  if (user == null) {
    return <PageLayout fullScreen={true}>
      <Stack gap={2} justifyContent="center" alignItems="center" flexGrow={1}>
        <Welcome/>
        <Stack gap={2} direction="row">
          <Button variant="contained" color="primary" onClick={signUp}><Trans
            i18nKey="auth:signUp.cta"/></Button>
          <Button variant="outlined" color="primary" onClick={signIn}><Trans
            i18nKey="auth:signIn.cta"/></Button>
        </Stack>
      </Stack>
    </PageLayout>
  }

  if (goSchoolUser == null || goSchoolUser.organization == null) {
    return <WarningPage icon={<LocationCityIcon/>} title={t('course:warnings.noOrganization.title')}>
      <Trans i18nKey="course:warnings.noOrganization.description"/>
      <Typography variant="caption" component="p" textAlign="center"><Link
        href="mailto:info@goschool.ai">info@goschool.ai</Link></Typography>
    </WarningPage>
  }

  return <CoursesPage/>
}
